
import * as React from 'react';
import moment from 'moment';

import { connect, Dispatch } from 'react-redux';
import { openMiniCalDialog, openFiltersDialog, removeAllEventFilters } from '../../redux-state/actions/calendar.actions';
import { ICalendarAppState } from '../../redux-state';
import FiltersContainer from '../filters-ace/container';
import ClearAll from '../filters-ace/clear-all';
import CalendarText from '../../contexts/calendar-text';
import { ICalendarFilterState } from '../../redux-state/interfaces/calendar-filter.state';
import { IEvent } from '../../interfaces';
import MonthSelectionDropdownBase from '../month-selection/dropdown';
import CalendarViewToggle from './../../components/calendar-view-toggle';

interface StateToProps {
    currentScrolledDate: moment.Moment;
    filterState: ICalendarFilterState<IEvent>;
    filtersBackgroundColor: string;
}

interface DispatchToProps {
    openMiniCalDialog: (trigger: HTMLButtonElement) => void;
    openFiltersDialog: (trigger: HTMLButtonElement) => void;
    clearAllFilters: () => void;
}

export type StickyNavProps = StateToProps & DispatchToProps;

/**
 * Displays the currently-scrolled month and a button to open the filters dialog.
 *
 * On mobile, also displays a button to open the mini-calendar dialog.
 */
export class StickyNavBase extends React.Component<StickyNavProps> {
    constructor(props: StickyNavProps) {
        super(props);
    }
    render() {
        const activeFilters =
            this.props.filterState.venueFilter.selectedOptions.length +
            this.props.filterState.availabilityFilter.selectedOptions.length +
            this.props.filterState.genreFilter.selectedOptions.length;

        return (
            <CalendarText.Consumer>
                {text => (
                    <>
                        <nav className={`bg-` + this.props.filtersBackgroundColor + ` sub-nav sub-nav-all-screens ace-cal-sub-nav` } aria-hidden="true" aria-label="Access Dates and Filters">
                            <div className="sub-nav-inner block-inner ">
                  
                                <header className="ace-cal-nav grid-container">
                                    <div className="ace-cal-filters">
                                        
                                        {this.props.openFiltersDialog}
                                        <MonthSelectionDropdownBase />
                                        <FiltersContainer />
                                    </div>
                                    <CalendarViewToggle />
                                </header>
                            </div>
                        </nav>
                    </>
                )}
            </CalendarText.Consumer>
        );
    }
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        filtersBackgroundColor: state.calendarText.calendarFiltersBackground,
        currentScrolledDate: state.calendar.currentScrolledDate,
        filterState: {
            ...state.calendar
        } as ICalendarFilterState<IEvent>
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchToProps {
    return {
        openMiniCalDialog: (trigger: HTMLButtonElement) => { dispatch(openMiniCalDialog(trigger)); },
        openFiltersDialog: (trigger: HTMLButtonElement) => { dispatch(openFiltersDialog(trigger)); },
        clearAllFilters: () => { dispatch(removeAllEventFilters()); },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StickyNavBase);
